const VALID_VERSIONS = ['v1', 'v2', 'v3']
const hpVersion = (() => {
  const v = localStorage.getItem('hp-version')
  if (v === 'new') return 'v2'
  if (v === 'legacy') return 'v1'
  return v && VALID_VERSIONS.includes(v) ? v : 'v1'
})()

if (hpVersion === 'v2') {
  import('./home-new/init')
} else if (hpVersion === 'v3') {
  import('./home-v3/init')
} else {
  import('./app-legacy')
}
